/**
 * Federated Components Registry for Coupon Microsite
 * Defines which components to load via Module Federation
 *
 * Remote URLs are resolved at RUNTIME from the moduleFederation context
 * (settings.json → configserver → context → Redux store → bootstrap),
 * following the same pipeline as featureFlags and preferences.
 *
 * The static __remotes from webpack config is kept as a build-time fallback
 * but is overridden at server startup by bootstrap.js with runtime-resolved URLs.
 */

const { getServerRemoteConfig } = require('../webpack/module-federation-config');
const { yodaCoreComponents } = require('./yodaCoreComponents'); 
const { yodaSiteComponents } = require('./yodaSiteComponents');

/**
 * Parses server remote configuration and extracts URLs
 * Handles both static config (name@url format) and promise-based config
 * @param {Object} [serverConfig] - Optional runtime remote config to use instead of webpack config
 * @returns {Object} Parsed remote configuration with URLs only
 */
const parseServerRemotes = (serverConfig) => {
    const config = serverConfig || getServerRemoteConfig();
    const parsed = {};

    Object.entries(config).forEach(([key, value]) => {
        // Handles both "name@url" (build-time) and plain URL (runtime via setRuntimeRemotes)
        parsed[key] = value.split('@')[1] || value;
    });

    return parsed;
};

/**
 * Mutable remotes store.
 * Initialized with build-time defaults from webpack config.
 * Overridden at runtime by bootstrap.js with context-resolved URLs.
 */
let _remotes = parseServerRemotes();

export const federatedComponents = {
    ...yodaCoreComponents,
    ...yodaSiteComponents,
    get __remotes() {
        return _remotes;
    },
    set __remotes(value) {
        _remotes = value;
    },
};

/**
 * Sets runtime remote URLs from the moduleFederation context.
 * Called by bootstrap.js during server startup with remotes resolved
 * from the micrositeSettings pipeline (settings.json → configserver → context).
 *
 * @param {Object} remoteConfig - Remote config object (name → URL mappings)
 */
export const setRuntimeRemotes = (remoteConfig) => {
    if (remoteConfig && typeof remoteConfig === 'object' && Object.keys(remoteConfig).length > 0) {
        console.log('[MFE] Setting runtime remotes from context:', Object.keys(remoteConfig));
        _remotes = parseServerRemotes(remoteConfig);
    }
};
